
// scrollTo.js https://gist.github.com/ravid7000/f54a37fd131a0b2e5ed190b6f58a1bc9

Math.easeInOutQuad = function (t, b, c, d) {
	t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};

/*
scrollTo(element, element.scrollTop || 200, 400)
*/
function scrollTo(element, to, duration = 400) {
	//const element = document.scrollingElement;
	const start = (element && element.scrollTop) || window.pageYOffset,
		change = to - start,
		increment = 20;
	let currentTime = 0;

	const animateScroll = function(){
		currentTime += increment;
		const val = Math.easeInOutQuad(currentTime, start, change, duration);
		element.scrollTo(0, val);
		if(currentTime < duration) {
			window.setTimeout(animateScroll, increment);
		}
	};

	animateScroll();
}

export { scrollTo }
